function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxFreezing24Hrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.68 103.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,28.93a3,3,0,0,0-4-1.33l-7.69,3.89-3-.91-4-7.86a3,3,0,0,0-5.36,2.69L8.66,37.89a3,3,0,0,0,1.4,1.36l.11,0a2,2,0,0,0,.39.14l.11,0,.17,0,.22,0a3.57,3.57,0,0,0,.46,0h0A3.05,3.05,0,0,0,13,39.06L25.17,33a3.4,3.4,0,0,0,.45-.28A3,3,0,0,0,26.5,28.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,11.72a3.13,3.13,0,0,0,1,.38,3,3,0,0,0,2.06-5.54C77,6,76.05,5.5,75.1,5h0c-1.19-.59-2.42-1.15-3.65-1.64A3,3,0,0,0,69.22,9c1.08.43,2.15.91,3.18,1.43C73.23,10.8,74.05,11.25,74.85,11.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.87,19a42.81,42.81,0,0,1,3.65,4.51,3,3,0,0,0,4.18.74,3,3,0,0,0,.74-4.18,47.2,47.2,0,0,0-4.19-5.16A3,3,0,1,0,83.87,19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.64,41.83a3.07,3.07,0,0,0,1.09,0,3,3,0,0,0,2.4-3.5,47.65,47.65,0,0,0-1.69-6.44,3,3,0,0,0-5.68,1.93,42.08,42.08,0,0,1,1.47,5.61A3,3,0,0,0,96.64,41.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66,51.9a3,3,0,0,0-6-.63c-.11,1.08-.27,2.17-.48,3.26-.15.82-.33,1.65-.53,2.46a3,3,0,0,0,2.18,3.64l.18,0a3,3,0,0,0,3.46-2.22c.23-.93.44-1.88.61-2.82C100.34,54.4,100.53,53.14,100.66,51.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.27,66.9a3,3,0,0,0-4.12,1,40,40,0,0,1-3.31,4.76,3,3,0,1,0,4.66,3.77A45.61,45.61,0,0,0,94.31,71,3,3,0,0,0,93.27,66.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.48,80.51c-.75.53-1.54,1-2.34,1.53a3,3,0,0,0,2.26,5.48,2.83,2.83,0,0,0,.85-.35c.91-.55,1.82-1.14,2.68-1.75a3,3,0,0,0-3.45-4.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38,37.08,11,37a3,3,0,0,1-2-3.74A46.92,46.92,0,0,1,59.11.29a3,3,0,0,1-.66,6A40.92,40.92,0,0,0,14.78,35,3,3,0,0,1,11.38,37.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.29,89.18l-5.73-4.26V74.85l7.66,4.43A18.93,18.93,0,0,1,38,75.5l-8.12-4.69,8.62-5V60.45L27.56,66.77V56.7l5.73-4.26a2.33,2.33,0,1,0-2.78-3.75l-3,2.19v-6.5a2.34,2.34,0,1,0-4.67,0v6.5l-2.95-2.19a2.33,2.33,0,0,0-2.77,3.75l5.72,4.26V66.77l-8.72-5-.82-7.09a2.33,2.33,0,1,0-4.64.52l.43,3.66L3.5,55.57a2.33,2.33,0,1,0-2.33,4L6.8,62.87,3.43,64.33a2.33,2.33,0,1,0,1.86,4.28l6.55-2.83,8.72,5-8.72,5L5.29,73a2.32,2.32,0,0,0-3.07,1.2A2.35,2.35,0,0,0,3.43,77.3L6.8,78.75,1.17,82a2.33,2.33,0,0,0,2.33,4l5.64-3.26-.43,3.66a2.34,2.34,0,0,0,4.64.53l.82-7.09,8.72-5V84.92l-5.72,4.26a2.33,2.33,0,1,0,2.77,3.75l2.95-2.19v6.51a2.34,2.34,0,0,0,4.67,0V90.74l3,2.19a2.33,2.33,0,1,0,2.78-3.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.8,
    cy: 88.52,
    r: 6.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,77.49a1.92,1.92,0,0,0-1.92,1.92v5.41a1.92,1.92,0,0,0,3.84,0V79.41A1.92,1.92,0,0,0,51.8,77.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,76.82V49.55a9.22,9.22,0,1,0-18.43,0V76.82a14.9,14.9,0,1,0,18.43,0ZM51.8,99A10.46,10.46,0,0,1,46,79.8l1-.66V49.55a4.78,4.78,0,1,1,9.55,0V79.14l1,.66A10.46,10.46,0,0,1,51.8,99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.31,71.88H54.86a2.07,2.07,0,1,1,0-4.13h3.45a2.07,2.07,0,0,1,0,4.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.31,63.81H54.86a2.07,2.07,0,1,1,0-4.13h3.45a2.07,2.07,0,0,1,0,4.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.31,55.74H54.86a2.06,2.06,0,1,1,0-4.12h3.45a2.06,2.06,0,0,1,0,4.12Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxFreezing24Hrs);
export default __webpack_public_path__ + "static/media/tx_freezing24hrs.2bcdf064be12a5ae2365e27e964364c9.svg";
export { ForwardRef as ReactComponent };